import qs from 'qs'
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

export function usePaginate(initialPage: number = 0) :[number,(page:number) => void]{
    const { search } = useLocation()
    const query = React.useMemo(() => qs.parse(search, { ignoreQueryPrefix: true }), [search])
    const navigate = useNavigate()

    const [page, setPage] = React.useState(initialPage)

    React.useEffect(() => setPage(query.page ? +query.page : 0), [query])

    function changeUrl(selectedPage: number) {
        setPage(selectedPage)
        navigate({
            pathname: '.',
            search: qs.stringify({ page: selectedPage }),
        })
    }

    return [page, changeUrl]
}
